import template from "./organization-profile.html";
import countriesTranslations from "../../../../common/translations/countries";

const OrganizationProfileComponent = {
  template: template,
  controller: class OrganizationProfileController {
    /* @ngInject */
    constructor(
      $rootScope,
      $state,
      $filter,
      Notification,
      Organization,
      OrganizationService,
      countries,
      Utils
    ) {
      this.$rootScope = $rootScope;
      this.$state = $state;
      this.$filter = $filter;
      this.NotificationService = Notification;
      this.Organization = Organization;
      this.OrganizationService = OrganizationService;
      this.countries = countries;

      this.countryFilter = Utils.filterDiacriticsInsensitive(
        countriesTranslations,
        $rootScope.organization.settings.appLanguage
      );
    }

    $onInit() {
      this.organization = this.$rootScope.organization;
      this.originalSlug = this.organization.slug;
      this.editableOrganization = angular.copy(this.organization);
      this.baseUrl = process.env.CLIENT_URL;
      this.loading = false;
    }
    async updateSlug() {
      if (!this.editableOrganization.name) this.editableOrganization.slug = "";
      else
        this.editableOrganization.slug =
          await this.editableOrganization.suggestSlug();
      this.$rootScope.$applyAsync();
    }

    async updateFromProfile() {
      if (!this.form.$valid) return;

      this.loading = true;
      const organization = await this.OrganizationService.updateOrganization(
        this.editableOrganization
      );
      if (organization) {
        this.organization = organization;
        this.NotificationService.success({
          title: this.$filter("trans")("notificationService.title.success"),
          message: this.$filter("trans")(
            "notificationService.message.organizationDataSaved"
          ),
        });
        if (this.originalSlug !== this.organization.slug) {
          return this.$state.go("app.organization.profile", {
            organization: this.organization.slug,
          });
        }
      }
      this.loading = false;
      this.$rootScope.$applyAsync();
    }
  },
};

export default OrganizationProfileComponent;
